import { chatApiConfig } from "./chatApiConfig";
import { maitrejaApiConfig } from "./maitrejaApiConfig";

export const apiConfig = {
  chatApi: chatApiConfig,
  maitrejaApi: maitrejaApiConfig,
} as const;
